import React from 'react';
import { motion } from 'framer-motion';
import { Icon } from '../ui/Icon';
const features = [{
  icon: 'video',
  title: '5 Grabaciones Completas del Bootcamp',
  description: 'Cada sesión dura de 2 a 3 horas, donde te enseño absolutamente TODO lo que aparece en mis webinars y diapositivas',
  highlights: ['Cómo elegir un nicho de mercado con demanda REAL', 'Cómo elegir productos que resuelven un dolor y que el mercado YA quiere comprar', 'Cómo crear un producto completo usando IA (imágenes, videos, copy, guiones)', 'Cómo escribir una carta de ventas persuasiva con frameworks de $100M', 'Cómo construir páginas de venta que convierten arriba del promedio', 'Cómo vender orgánicamente sin usar ads', 'Cómo escalar con tráfico pagado de forma rentable y rápida']
}];
export function WhatYouGet() {
  return <section className="py-20 bg-white" data-id="element-285">
      <div className="max-w-6xl mx-auto px-6" data-id="element-286">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-287">
          <div className="inline-flex items-center gap-2 bg-black text-yellow-400 px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wider mb-4" data-id="element-288">
            <Icon name="gift" size={18} data-id="element-289" />
            Qué Incluye
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-black mb-4" data-id="element-290">
            ¿Qué Incluye Exactamente Este Black Friday Special?
          </h2>
        </motion.div>

        {features.map((feature, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: index * 0.1
      }} className="bg-gradient-to-br from-gray-50 to-white border-2 border-gray-200 rounded-2xl p-8 md:p-12 mb-8" data-id="element-291">
            <div className="flex items-start gap-6 mb-8" data-id="element-292">
              <div className="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-xl flex items-center justify-center" data-id="element-293">
                <Icon name={feature.icon as any} size={32} className="text-black" data-id="element-294" />
              </div>
              <div data-id="element-295">
                <h3 className="text-2xl md:text-3xl font-bold text-black mb-3" data-id="element-296">
                  {feature.title}
                </h3>
                <p className="text-lg text-gray-700 leading-relaxed" data-id="element-297">
                  {feature.description}
                </p>
              </div>
            </div>

            <div className="grid gap-4" data-id="element-298">
              {feature.highlights.map((highlight, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.3 + i * 0.05
          }} className="flex items-start gap-4 bg-white rounded-lg p-4 border border-gray-200" data-id="element-299">
                  <div className="flex-shrink-0 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center mt-0.5" data-id="element-300">
                    <Icon name="check" size={16} className="text-white" data-id="element-301" />
                  </div>
                  <p className="text-gray-800 font-medium leading-relaxed" data-id="element-302">
                    {highlight}
                  </p>
                </motion.div>)}
            </div>
          </motion.div>)}
      </div>
    </section>;
}